<div class="navigation-scrim" (click)="close()"></div>

<div class="navigation-menu" [ngClass]="theme">
    <div class="header">
        <button class="toggle-btn" (click)="toggleActive()">
            <mat-icon>{{isActive() ? 'menu_open' : 'menu'}}</mat-icon>
        </button>
    </div>

    @for (group of items; track group.label) {
    <div class="list-group" [class.isOpen]="isActive()">
        @if (group.label) {
        <div class="group-label">{{ group.label | translate }}</div>
        }
        @for (item of group.items; track item.routerLink) {
        <button class="link-item relative" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
            [routerLink]="item.routerLink" (click)="item.click ? item.click() : null">
            @if (item.iconType == 'material') {
            <mat-icon class="icon">{{item.icon}}</mat-icon>
            } @else if (item.iconType == 'svg-icon') {
            <mat-icon class="icon" [svgIcon]="item.icon"></mat-icon>
            } @else if (item.iconType == 'fa') {
            <mat-icon class="icon" fontSet="fa" [fontIcon]="item.icon"></mat-icon>
            } @else {
            <img class="icon" [src]="item.icon">
            }
            <div *ngIf="item.shortLabel" class="short-label text-xxs capitalize">{{ item.shortLabel | translate }}</div>
            <div class="label capitalize">{{ item.label | translate }}</div>
            @if(item.badge){
            <div
                class="flex justify-center items-center absolute rounded-full min-w-4 px-1 bg-[#ff5050] rtl:left-3 ltr:right-3 top-1 text-white text-xxs text-center">
                @if(item.badge.value && item.badge.type == 'number'){
                {{item.badge.value}}
                }
            </div>}
        </button>
        }
    </div>
    }
</div>